__turbopack_context__.v({
  "checkboxInput": "formInputs-module-scss-module__8NvIaG__checkboxInput",
  "checkempty": "formInputs-module-scss-module__8NvIaG__checkempty",
  "checkmark": "formInputs-module-scss-module__8NvIaG__checkmark",
  "errorIcon": "formInputs-module-scss-module__8NvIaG__errorIcon",
  "icon": "formInputs-module-scss-module__8NvIaG__icon",
  "textInput": "formInputs-module-scss-module__8NvIaG__textInput",
});
